import {
  get,
  post,
  del,
  put,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'


// 新增通知
export function addPartyNotice(params) {
  return post(`${HOST}party_notice/save`, params)
}
// 修改通知
export function updatePartyNotice(params) {
  return put(`${HOST}party_notice/put`, params)
}
//通知
export function getPartyNotice(params) {
  return get(`${HOST}party_notice/list`, params)
}
//通知草稿箱列表
export function PartyNoticeDraftlist(params) {
  return get(`${HOST}party_notice/draftlist`, params)
}
//通知详情
export function PartyNoticeDetial(params) {
  return get(`${HOST}party_notice/listDetails`, params)
}
// 删除通知
export function delPartyNotice(params) {
  return del(`${HOST}party_notice/delete`, params)
}
//回复列表
export function replyDetails(params) {
  return get(`${HOST}party_notice/replyDetails`, params)
}
//接收列表
export function partyNoticeUserList(params) {
  return get(`${HOST}party_notice_user/list`, params)
}
//回复详情
export function partyNoticeUserDetial(params) {
  return get(`${HOST}party_notice_user/listDetails`, params)
}
// 通知确认
export function affirmPartyNotice(params) {
  return get(`${HOST}party_notice_user/affirmPartyNotice`, params)
}
// 撤回
export function withdrawParty(params) {
  return get(`${HOST}party_notice/withdrawParty`, params)
}
// 回复
export function updatepartyNoticeUser(params) {
  return put(`${HOST}party_notice_user/put`, params)
}
//获取人员分组列表
export function getSendList(params) {
  return get(`${HOST}sys-send/list`, params)
}
// 通过id获取文件信息
export function createWord(id) {
  return get(`${HOST}party_notice/partyWord`, { id })
}
//新增本期民福部分begin
//已发通知列表
export function mfNoticeList(params) {
  return get(`${HOST}mf_notice/list`, params)
}
// 新增通知
export function mfNoticeSave(params) {
  return post(`${HOST}/mf_notice/save`, params)
}

//通知详情
export function mfNoticeListDetails(params) {
  return get(`${HOST}mf_notice/listDetails`, params)
}
// 撤回
export function mfNoticeWithdrawParty(params) {
  return get(`${HOST}mf_notice/withdrawParty`, params)
}
// 删除通知
export function mfNoticeDelete(params) {
  return del(`${HOST}mf_notice/delete`, params)
}
// 修改通知
export function mfNoticePut(params) {
  return put(`${HOST}mf_notice/put`, params)
}
//已收通知列表
export function mfNoticeUserList(params) {
  return get(`${HOST}mf_notice_user/list`, params)
}
//确认 mf_notice_user/affirmPartyNotice
export function mfNoticeUserAffirmPartyNotice(params) {
  return get(`${HOST}mf_notice_user/affirmPartyNotice?id=${params}`)
}

// 通过id获取文件信息 民福
export function createWordMF(id) {
  return get(`${HOST}mf_notice/partyWord`, { id })
}
//新增本期民福部分end


// 通知管理-已发通知-下载短信发送结果
export function exportNoticeResult(id) {
  return getfile(`${HOST}mf_notice/export`, { id })
}


// WEBPACK FOOTER //
// ./src/views/notification/api/api.js